import { render, staticRenderFns } from "./Userpage.vue?vue&type=template&id=700f76d1&scoped=true&"
import script from "./Userpage.vue?vue&type=script&lang=js&"
export * from "./Userpage.vue?vue&type=script&lang=js&"
import style0 from "./Userpage.vue?vue&type=style&index=0&id=700f76d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700f76d1",
  null
  
)

export default component.exports